/* eslint-disable default-case */
/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Grid, Backdrop, CircularProgress, FormControlLabel, Checkbox } from "@mui/material";
import { postApi, getApi } from "../../../store/apis";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { Close as CloseIcon, Person, Email, Key, LocationOn, PhoneIphone, ChevronLeft, ChevronRight, Check, AccountCircle, GridView, Business } from "@mui/icons-material";
import InputWithIcon from "../../../components/base/inputWithIcon";
import SelectWithIcon from "../../../components/base/selectWithIcon";
import AreaWithIcon from "../../../components/base/areaWithIcon";

const CompanyCreate = ({ d_create = false, close, refetch }) => {
  const theme = useSelector((state) => state.theme.myTheme);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [listAcc, setListAcc] = useState([]);
  const [acc, setAcc] = useState([]);
  const [loadAcc, setLoadAcc] = useState(false);
  const listJenis = ["Profesional", "Pendidikan"];
  const listStep = [1, 2, 3, 4];
  const [step, setStep] = useState(listStep[0]);

  const [field, setField] = useState([
    {
      username: "",
      password: "",
    },
    {
      nama: "",
      jenis: "",
      email: "",
      no_kontak: "",
      alamat: "",
    },
    {
      nama_klien: "",
      email_klien: "",
      no_telp: "",
    },
    {
      permission: [],
    },
  ]);

  const renderContent = (stepData) => {
    let content = <></>;
    switch (stepData) {
      case 1:
        content = contentKonselor();
        break;
      case 2:
        content = contentCompany();
        break;
      case 3:
        content = contentPic();
        break;
      case 4:
        content = contentPermission();
        break;
      default:
        content = <></>;
        break;
    }

    return content;
  };

  const handleChange = (prop) => (event) => {
    field[step - 1][prop] = event.target.value;
    setField([...field]);
  };

  const handleGetField = (prop) => {
    let data = field[step - 1][prop];
    return data;
  };

  const handleCheck = (item) => (event) => {
    const { checked } = event.target;
    if (checked) {
      setAcc([...acc, item]);
    } else {
      setAcc(acc.filter((val) => val !== item));
    }

    // field data permission
    field[step - 1]["permission"] = JSON.stringify(acc);
    setField([...field]);
  };

  const resetAndDone = () => {
    listStep.forEach((item, index) => {
      Object.keys(field[index]).forEach((itemChild, indexChild) => {
        field[index][itemChild] = "";
      });
    });
    field[listStep.length - 1].permission = [];

    setField([...field]);
    setStep(listStep[0]);
    refetch();
    close();
  };

  const switchStep = (event) => {
    switch (event) {
      case "prev":
        setStep(step - 1);
        break;
      default:
        postData(step, () => {
          if (step >= listStep.length) {
            resetAndDone();
          } else {
            setStep(step + 1);
          }
        });
        break;
    }
  };

  const fetchPermission = () => {
    setLoadAcc(true);
    let data = {
      path: `admin/permission/company`,
    };
    dispatch(getApi(data))
      .then((data) => {
        setLoadAcc(false);
        setListAcc(data);
      })
      .catch((err) => {
        setLoadAcc(false);
        setListAcc([]);
      });
  };

  const getBody = () => {
    return field[step - 1];
  };

  const postData = (stepData = 0, onSuccess) => {
    setLoading(true);
    let data = {
      path: "admin/company/create",
      body: {
        step: stepData,
        ...getBody(),
      },
    };
    dispatch(postApi(data))
      .then((data) => {
        setLoading(false);
        step === listStep.length && enqueueSnackbar("Akun berhasil dibuat", { variant: "success" });
        onSuccess && onSuccess();
      })
      .catch((err) => {
        const variant = "error";
        if (err.status === "bad_request") {
          const error = err?.data?.errors ?? { validasi: ["data tidak valid"] };
          Object.keys(error).forEach((message) => {
            enqueueSnackbar(error[message], { variant });
          });
        } else {
          enqueueSnackbar(err.message ?? "Akun gagal dibuat", { variant });
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchPermission();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const contentKonselor = () => {
    return (
      <div className="px-2">
        <p className="font-weight-bold mb-3" style={{ color: theme.primary }}>
          Buat Akun Klien
        </p>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <p className="font-weight-bold small_txt" style={{ color: theme.primary }}>
              Username
            </p>
            <InputWithIcon value={handleGetField("username")} icon={<AccountCircle color="primary" />} handleChange={handleChange} property="username" />
          </Grid>
          <Grid item xs={12}>
            <p className="font-weight-bold small_txt" style={{ color: theme.primary }}>
              Password
            </p>
            <InputWithIcon value={handleGetField("password")} icon={<Key color="primary" />} handleChange={handleChange} type="password" property="password" />
            <small className="small_txt">Password harus memiliki setidaknya 6 karakter, satu digit, satu huruf kecil, satu huruf besar, dan satu simbol</small>
          </Grid>
        </Grid>
      </div>
    );
  };

  const contentCompany = () => {
    return (
      <div className="px-2">
        <p className="font-weight-bold mb-3" style={{ color: theme.primary }}>
          Informasi Company
        </p>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <p className="font-weight-bold small_txt" style={{ color: theme.primary }}>
              Nama Company/Institution
            </p>
            <InputWithIcon value={handleGetField("nama")} icon={<Business color="primary" />} handleChange={handleChange} property="nama" />
          </Grid>
          <Grid item xs={12}>
            <p className="font-weight-bold small_txt" style={{ color: theme.primary }}>
              Jenis Company/Institution
            </p>
            <SelectWithIcon value={handleGetField("jenis")} handleChange={handleChange} list={listJenis} icon={<GridView color="primary" />} property="jenis" />
          </Grid>
          <Grid item xs={12}>
            <p className="font-weight-bold small_txt" style={{ color: theme.primary }}>
              Email Aktif
            </p>
            <InputWithIcon value={handleGetField("email")} icon={<Email color="primary" />} handleChange={handleChange} property="email" />
          </Grid>
          <Grid item xs={6}>
            <p className="font-weight-bold small_txt" style={{ color: theme.primary }}>
              Nomor Telepon
            </p>
            <InputWithIcon value={handleGetField("no_kontak")} icon={<PhoneIphone color="primary" />} handleChange={handleChange} type="number" property="no_kontak" />
          </Grid>
          <Grid item xs={12}>
            <AreaWithIcon value={handleGetField("alamat")} icon={<LocationOn color="primary" />} handleChange={handleChange} property="alamat" />
          </Grid>
        </Grid>
      </div>
    );
  };

  const contentPic = () => {
    return (
      <div className="px-2">
        <p className="font-weight-bold mb-3" style={{ color: theme.primary }}>
          Informasi Penanggung Jawab
        </p>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <p className="font-weight-bold small_txt" style={{ color: theme.primary }}>
              Nama Penanggung Jawab
            </p>
            <InputWithIcon value={handleGetField("nama_klien")} icon={<Person color="primary" />} handleChange={handleChange} property="nama_klien" />
          </Grid>
          <Grid item xs={12}>
            <p className="font-weight-bold small_txt" style={{ color: theme.primary }}>
              Email Aktif
            </p>
            <InputWithIcon value={handleGetField("email_klien")} icon={<Email color="primary" />} handleChange={handleChange} property="email_klien" />
          </Grid>
          <Grid item xs={12}>
            <p className="font-weight-bold small_txt" style={{ color: theme.primary }}>
              Nomor Hp
            </p>
            <InputWithIcon value={handleGetField("no_telp")} icon={<PhoneIphone color="primary" />} handleChange={handleChange} type="number" property="no_telp" />
          </Grid>
        </Grid>
      </div>
    );
  };

  const contentPermission = () => {
    return (
      <div>
        <p className="font-weight-bold" style={{ color: theme.primary }}>
          Access Permission
        </p>
        <p className="small_txt text-grey mb-3" style={{ color: theme.primary }}>
          Beri centang untuk fitur yang bisa diakses dan diubah konselor
        </p>
        <div className="mb-4">
          {loadAcc && listAcc.length ? (
            <CircularProgress color="inherit" />
          ) : (
            <div>
              {listAcc.map((item, i) => (
                <FormControlLabel key={i} label={item.name} control={<Checkbox checked={acc.includes(item.name)} onChange={handleCheck(item.name)} />} />
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <Dialog
      open={d_create}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: { borderRadius: 10 },
      }}>
      <DialogTitle id="alert-dialog-title" className="py-3">
        <div className="d-flex justify-space-between">
          <h4>Tambah Company/Institution</h4>
          <IconButton onClick={close}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className="styled_scroll" style={{ overflowX: "hidden" }}>
        <div className="borbox" style={{ width: "450px", padding: "5px", minHeight: "400px" }}>
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <div className="d-flex mb-3">
            {listStep.map((stp, i) => (
              <div
                key={`step-${i}`}
                style={{
                  border: `2px solid ${theme.lighten}`,
                  color: step === stp ? theme.primary : theme.lighten,
                  background: step === stp ? theme.lighten : step > stp ? theme.primary : "#fff",
                }}
                className="steper mr-2">
                {step > stp ? <Check fontSize="small" /> : stp}
              </div>
            ))}
          </div>
          {renderContent(step)}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="d-flex justify-end px-5 pb-5">
          {step <= 1 ? (
            <></>
          ) : (
            <Button variant="contained" onClick={() => switchStep("prev")} className="capitalize rounded-lg mr-2 px-0" style={{ minWidth: "0" }} disableElevation>
              {" "}
              <ChevronLeft />{" "}
            </Button>
          )}
          {step < 4 ? (
            <Button onClick={() => switchStep("next")} variant="contained" className="capitalize rounded-lg" style={{ minWidth: "0" }} disableElevation>
              {" "}
              <ChevronRight />{" "}
            </Button>
          ) : (
            <Button onClick={() => switchStep("next")} variant="contained" className="capitalize rounded-lg" disableElevation>
              <p className="font-weight-bold">Buat Akun</p>
            </Button>
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default CompanyCreate;
